<template>
    <div>
        <div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				<!--{{ $t('Create goods') }}-->
				{{ $t('goods.create.title') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>

    </div>
</template>
<script>


export default {
    methods: {
        cancel() {
            this.$emit('close')
        }
    }
}
</script>
